"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpServiceRequest = void 0;
var XhrHttpHandler_1 = require("./XhrHttpHandler");
var objectUtil_1 = require("../../util/objectUtil");
var cloneHttpOptions_1 = require("../../util/cloneHttpOptions");
var hasOwnProperty_1 = require("../../util/hasOwnProperty");
/**
 * @category HTTP
 */
var HttpServiceRequest = /** @class */ (function () {
    function HttpServiceRequest(options) {
        var e_1, _a;
        this.options = options;
        /**
         * All header keys are normalized to lower-case
         */
        this.headers = new Map();
        if ((0, hasOwnProperty_1.hasOwnProperty)(options, 'headers')) {
            HttpServiceRequest.normalizeHeaders(options.headers);
        }
        if (options.headers) {
            try {
                for (var _b = __values(Object.keys(options.headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this.headers.set(HttpServiceRequest.normalizeHeaderKey(key), options.headers[key]);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    }
    HttpServiceRequest.prototype.addHeader = function (key, value) {
        if (this.headers.get(key)) {
            console.info("setting ".concat(key, " header twice"));
        }
        this.headers.set(HttpServiceRequest.normalizeHeaderKey(key), value);
        return this;
    };
    HttpServiceRequest.prototype.addHeaders = function (headers) {
        for (var key in Object.keys(headers)) {
            this.addHeader(key, headers[key]);
        }
        return this;
    };
    HttpServiceRequest.prototype.removeHeader = function (key) {
        key = HttpServiceRequest.normalizeHeaderKey(key);
        this.headers.delete(key);
        return this;
    };
    HttpServiceRequest.prototype.send = function () {
        return new XhrHttpHandler_1.XhrHttpHandler();
    };
    HttpServiceRequest.prototype.clone = function (update) {
        if (update && update.headers) {
            HttpServiceRequest.normalizeHeaders(update === null || update === void 0 ? void 0 : update.headers);
        }
        var options = update ? (0, objectUtil_1.deepMerge)((0, cloneHttpOptions_1.cloneHttpOptions)(this.options), update) : this.options;
        return new HttpServiceRequest(options);
    };
    /**
     * Normalizes header names for easier string name comparisons. Ex: Content-Type turns into content-type     * @param key
     * @private
     */
    HttpServiceRequest.normalizeHeaderKey = function (key) {
        return key
            .split('-')
            .map(function (str) { return "".concat(str.substring(0, 1).toLocaleLowerCase()).concat(str.substring(1)); })
            .join('-');
    };
    /**
     * Normalizes header names for easier string name comparisons. Ex: Content-Type turns into content-type
     * @param headers
     * @private
     */
    HttpServiceRequest.normalizeHeaders = function (headers) {
        for (var key in headers) {
            var newKey = this.normalizeHeaderKey(key);
            if (key !== newKey) {
                headers[newKey] = headers[key];
                delete headers[key];
            }
        }
    };
    return HttpServiceRequest;
}());
exports.HttpServiceRequest = HttpServiceRequest;
//# sourceMappingURL=HttpServiceRequest.js.map